import axiosInstance from "@/api/axios-instance";

// Pricing-change lifecycle actions (see the pricing-lifecycle design doc).

// Partial Release: expose a new experimental price to cohorts entering on/after
// `released_at`, cloned from the offering's current baseline (`baselineId`).
// Existing prices are untouched.
export interface PartialReleasePayload {
  amount: number; // the experimental price (absolute)
  released_at: string; // ISO 8601 — when it becomes visible to new cohorts
  // The new version's per-session price; omitted → the baseline's carries over.
  single_session_amount?: number;
}

export async function partialReleaseBundle(
  baselineId: string,
  payload: PartialReleasePayload,
) {
  return (
    await axiosInstance.post(`/bundle/${baselineId}/partial-release`, payload)
  ).data;
}

// Bulk Partial Release: expose new experimental prices for many offerings at
// once, all sharing one release date.
export interface BulkPartialReleaseItem {
  baselineId: string; // the offering's current baseline bundle id
  amount: number; // the experimental price for it (absolute)
}

export async function partialReleaseBundlesBulk(
  releases: BulkPartialReleaseItem[],
  released_at: string,
) {
  return (
    await axiosInstance.post(`/bundle/partial-release/bulk`, {
      releases,
      released_at,
    })
  ).data;
}

// Full Rollout: confirm a version (`bundleId`) as the production price for
// everyone — promote it to baseline and retire the rest.
export async function fullRolloutBundle(bundleId: string) {
  return (await axiosInstance.post(`/bundle/${bundleId}/full-rollout`, {})).data;
}

// Group (cohort) Full Rollout: promote many versions at once — one per offering,
// the price effective for a cohort window — to baseline for everyone, atomically.
export async function fullRolloutBundlesBulk(bundleIds: string[]) {
  return (
    await axiosInstance.post(`/bundle/full-rollout/bulk`, {
      bundle_ids: bundleIds,
    })
  ).data;
}
